'use es6';

const SCOPE_SUPER_ADMIN = 'super-admin';
export const isSuperAdmin = user => user.scopes.indexOf(SCOPE_SUPER_ADMIN) !== -1;